import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { URL_IMAGES_FLAG } from 'constants/UrlConstants';

import media from 'theme/media';

const getSize = (props) => {
    switch (props.size) {
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '40px':
            return '40px';
        case 'x-small':
            return '24px';
        default:
            return '24px';
    }
};

const getDesktopSize = (props) => {
    switch (props.size) {
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '40px':
            return '40px';
        case 'x-small':
            return '28px';
        default:
            return '24px';
    }
};

const PngIcon = styled.span`
    display: inline-block;
    position: relative;
    width: ${(props) => getSize(props)};
    height: ${(props) => getSize(props)};
    overflow: hidden;
    border-radius: 50%;
    vertical-align: top;
    opacity: ${(props) => (props.isDisabled ? '0.32' : null)};
    flex-shrink: 0;

    &:before {
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 50%;
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }

    img {
        max-width: 100%;
    }

    ${media.desktop1920} {
        width: ${(props) => getDesktopSize(props)};
        height: ${(props) => getDesktopSize(props)};
    }
`;

export const LightFlagIcon = (props) => {
    if (props.name) {
        return (
            <PngIcon size={props.size} isDisabled={props.isDisabled}>
                <img src={`${URL_IMAGES_FLAG}/${props.name}.png`} alt={props.name} loading="lazy" decoding="async" />
            </PngIcon>
        );
    }
    return null;
};

LightFlagIcon.propTypes = {
    name: PropTypes.string,
    size: PropTypes.oneOf(['16px', '24px', '40px', 'x-small']),
    isDisabled: PropTypes.bool,
};
